import React from "react";
import { styled } from "@mui/material/styles";

import { withState } from "../../../services/state";

import Button from "../button/Button";

import Logo from "./Logo.png";

const AuthenticationFlowWrapper = styled("div")({
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const AuthenticationFlowRoot = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: 3,
  width: "100%",
  maxWidth: 1200,
  maxHeight: 800,
  height: "100%",
  overflow: "auto",
  display: "flex",
  boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
  [theme.breakpoints.down("sm")]: {
    display: "block",
  },
}));

const AuthenticationFlowSidebar = styled("div")(({ theme }) => ({
  backgroundColor: "#393A39",
  color: "#fff",
  width: 150,
  position: "relative",
  padding: 10,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const AuthenticationFlowLogo = styled("img")({
  width: "100%",
  maxWidth: 100,
});

const CurrentStep = styled("div")(({ theme }) => ({
  width: "calc(100% - 150px)",
  padding: 40,
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const StepNumber = styled("div")({
  color: "#9C9C9C",
  marginBottom: 20,
});

const BackButtons = styled("div")({
  color: "#9C9C9C",
  position: "absolute",
  bottom: 20,
  left: 0,
  textAlign: "center",
  cursor: "pointer",
  width: "100%",
});

const StepTracker = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  marginBottom: 80,
});

const StepTrackerBar = styled("div")({
  width: "100%",
  height: 3,
  backgroundColor: "#393a39",
});

const StepTrackerBarCurrentProgress = styled("div")({
  height: 3,
  backgroundColor: "#00823e",
  position: "absolute",
  zIndex: 50,
  left: 0,
  minWidth: 30,
});

const StepTrackerSteps = styled("div")({
  display: "flex",
  zIndex: 100,
  alignItems: "center",
  justifyContent: "space-between",
  position: "absolute",
  width: "100%",
  textAlign: "center",
});

const StepTrackerStepNumber = styled("div")({
  width: 36,
  height: 36,
  borderRadius: 18,
  backgroundColor: "#00823e",
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  marginTop: 14,
});

function renderCurrentStep(currentStep) {
  return currentStep;
}

function AuthenticationFlow({
  dispatch,
  style,
  currentStep,
  steps,
  onGoBack,
  onLogout,
  showStepTracker,
  onStepClick,
}) {
  const renderSteps = () => {
    return steps.map((_, i) => (
      <div
        key={i}
        onClick={() => i < currentStep && onStepClick(i)}
        style={{
          filter: i > currentStep ? "grayscale(100%)" : "none",
          cursor: i < currentStep ? "pointer" : "default",
        }}
      >
        <StepTrackerStepNumber>{i + 1}</StepTrackerStepNumber>
        <div>Step {i + 1}</div>
      </div>
    ));
  };

  return (
    <AuthenticationFlowWrapper>
      <AuthenticationFlowRoot style={style || {}}>
        <AuthenticationFlowSidebar>
          <AuthenticationFlowLogo alt="Slate logo" src={Logo} />
          <BackButtons>
            {onGoBack && (
              <Button
                style={{
                  backgroundColor: "rgb(243, 243, 243)",
                  color: "#222",
                  marginBottom: 10,
                }}
                title="Back"
                onClick={onGoBack}
              />
            )}
            {currentStep === 0 && onLogout && (
              <Button
                style={{ backgroundColor: "rgb(243, 243, 243)", color: "#222" }}
                title="Logout"
                onClick={onLogout}
              />
            )}
          </BackButtons>
        </AuthenticationFlowSidebar>
        <CurrentStep>
          {!showStepTracker && steps.length > 1 && (
            <StepNumber>Step {currentStep + 1}</StepNumber>
          )}
          {showStepTracker && steps.length > 1 && (
            <StepTracker>
              <StepTrackerBar />
              <StepTrackerBarCurrentProgress
                style={{
                  width: `${(currentStep / (steps.length - 1)) * 100}%`,
                }}
              />
              <StepTrackerSteps>{renderSteps()}</StepTrackerSteps>
            </StepTracker>
          )}
          {renderCurrentStep(steps[currentStep])}
        </CurrentStep>
      </AuthenticationFlowRoot>
    </AuthenticationFlowWrapper>
  );
}

export default withState(AuthenticationFlow);
